var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-2 font-weight-bold grey--text text--darken-2",staticStyle:{"height":"28px"}},[_c('div',{staticClass:"pt-1"},[_vm._v(" Size: "),(_vm.variable)?_c('span',[_vm._v(_vm._s(_vm.variable.name))]):_c('span',[_vm._v("None")])]),_c('v-spacer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }